module.exports = __webpack_public_path__ + "img/standardModel-icon-sentio.1dc4c3ef.png";